module.exports = __webpack_public_path__ + "img/refreshing.b846d18d.png";